class OSProductEditorialMobileGallery extends HTMLElement {
  connectedCallback() {
    this.osViewport = this.querySelector('[data-os-mobile-gallery-viewport]');
    this.osSlides = Array.from(this.querySelectorAll('[data-os-mobile-slide-index]'));
    this.osDots = Array.from(this.querySelectorAll('[data-os-mobile-gallery-dot]'));
    this.osCurrentIndex = 0;

    if (!this.osViewport || this.osSlides.length === 0) return;

    this.osDots.forEach((osDot) => osDot.addEventListener('click', this.osHandleDotClick));
    this.osViewport.addEventListener('scroll', this.osHandleScroll, { passive: true });

    const osInitialIndex = this.osSlides.findIndex(
      (osSlide) => String(osSlide.dataset.osMobileMediaId) === String(this.dataset.initialMediaId)
    );

    requestAnimationFrame(() => this.osGoToSlide(osInitialIndex >= 0 ? osInitialIndex : 0, false));

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      this.osVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.osHandleVariantChange
      );
    }
  }

  disconnectedCallback() {
    this.osDots?.forEach((osDot) => osDot.removeEventListener('click', this.osHandleDotClick));
    this.osViewport?.removeEventListener('scroll', this.osHandleScroll);
    this.osVariantChangeUnsubscriber?.();
    cancelAnimationFrame(this.osScrollFrame);
  }

  osHandleDotClick = (osEvent) => {
    const osIndex = Number(osEvent.currentTarget.dataset.osMobileGalleryDot);
    this.osGoToSlide(osIndex, true);
  };

  osHandleScroll = () => {
    cancelAnimationFrame(this.osScrollFrame);
    this.osScrollFrame = requestAnimationFrame(() => {
      const osWidth = this.osViewport.clientWidth;
      if (!osWidth) return;

      const osIndex = Math.round(this.osViewport.scrollLeft / osWidth);
      this.osUpdateState(Math.min(Math.max(osIndex, 0), this.osSlides.length - 1));
    });
  };

  osGoToSlide(osIndex, osSmooth) {
    const osSlide = this.osSlides[osIndex];
    if (!osSlide) return;

    this.osViewport.scrollTo({
      left: osSlide.offsetLeft,
      behavior: osSmooth ? 'smooth' : 'auto',
    });
    this.osUpdateState(osIndex);
  }

  osUpdateState(osIndex) {
    this.osCurrentIndex = osIndex;

    this.osSlides.forEach((osSlide, osSlideIndex) => {
      osSlide.setAttribute('aria-hidden', osSlideIndex === osIndex ? 'false' : 'true');
    });

    this.osDots.forEach((osDot, osDotIndex) => {
      const osIsActive = osDotIndex === osIndex;
      osDot.classList.toggle('is-active', osIsActive);
      osDot.setAttribute('aria-current', osIsActive ? 'true' : 'false');
    });
  }

  osHandleVariantChange = ({ data }) => {
    if (String(data?.sectionId) !== String(this.dataset.sectionId)) return;

    const osFeaturedMediaId = data?.variant?.featured_media?.id;
    if (!osFeaturedMediaId) return;

    const osVariantIndex = this.osSlides.findIndex(
      (osSlide) => String(osSlide.dataset.osMobileMediaId) === String(osFeaturedMediaId)
    );

    if (osVariantIndex >= 0 && osVariantIndex !== this.osCurrentIndex) {
      this.osGoToSlide(osVariantIndex, true);
    }
  };
}

if (!customElements.get('os-product-editorial-mobile-gallery')) {
  customElements.define('os-product-editorial-mobile-gallery', OSProductEditorialMobileGallery);
}
